<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.hospitalisations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body p-0 mt-3">
                <b-form @reset="onReset" v-if="show">
                    <b-container class="p-0">
                        <!-- <div class="form-group col-md-12">
                            <span class="obligatoire">*</span>
                            <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                            <autocomplete
                                :search="getEtablisssements"
                                placeholder="Rechercher l'établissement"
                                aria-label="Rechercher l'établissement"
                                :get-result-value="getValueEtablissement"
                                @submit="chooseEtablissement"
                            ></autocomplete>
                            <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.form.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                            <small id="emailHelp" class="form-text text-danger" v-if="$v.form.etablissement_id.$error">Rassurez-vous d'avoir sélectionné l'établissement</small> 
                        </div> -->
                        <div>
                            <b-row class="p-0">
                                <b-col sm="12">
                                    <span class="obligatoire">*</span>
                                    <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                                        <multiselect v-model="$v.form.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                                        <b-form-invalid-feedback v-if="$v.form.activity_id.$error">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
                                        <span v-if="errorshasField('activity_id')" style="color:red">
                                            {{getErrorsField('activity_id')}}
                                        </span>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <span class="obligatoire">*</span>
                                    <b-form-group id="timeLine-group" :label="$tc('message.TimelineSelect', 2)" label-for="singleMotif" >
                                        <select id="timeLine" v-model="$v.form.ligne_de_temps_id.$model" class="form-control is-invalid retirerBordure" @change="clearErrorField('ligne_de_temps_id')" required>
                                            <option data-placeholder="true"></option>
                                            <option v-for="item in lignetempsRows" :key="item.id" :value="item.id">
                                                {{item.motif}} <b-badge variant="info">{{item.date}}</b-badge>
                                            </option>
                                        </select>
                                    <b-form-invalid-feedback v-if="$v.form.ligne_de_temps_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('ligne_de_temps_id')" style="color:red">
                                        {{getErrorsField('ligne_de_temps_id')}}
                                    </span>
                                        
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="institution-group"
                                        :label="$t('message.institutionConsultation')"
                                        label-for="institution"
                                >
                                    <select id="institution" v-model="$v.form.institution.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            required
                                            class="form-control is-invalid retirerBordure"

                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.institution.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="singleMotif-group"
                                        :label="$tc('message.reasons', 2)"
                                        label-for="singleMotif"
                                >
                                    <select id="singleMotif" v-model="$v.form.motifs.$model" multiple
                                            @change="clearErrorField('motifs')"
                                            required
                                            class="form-control is-invalid retirerBordure"

                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mReasons" :key="item.value" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.motifs.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('motifs')" style="color:red">
                                    {{getErrorsField('motifs')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="entree-group"
                                        :label="$t('message.entryDate')"
                                        label-for="entree"
                                        description="">
                                    <b-form-input
                                            id="entree"
                                            v-model="$v.form.date_entree.$model"
                                            :state="$v.form.date_entree.$dirty ? !(errorshasField('date_entree') || $v.form.date_entree.$error) : null"
                                            type="date"
                                            required
                                            @focus="clearErrorField('date_entree')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.date_entree.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('date_entree')">
                                        {{ getErrorsField('date_entree') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="sortie-group"
                                        :label="$t('message.exitDate')"
                                        label-for="sortie"
                                        description="">
                                    <b-form-input
                                            id="sortie"
                                            v-model="$v.form.date_sortie.$model"
                                            :state="$v.form.date_sortie.$dirty ? !(errorshasField('date_sortie') || $v.form.date_sortie.$error) : null"
                                            type="date"
                                            @focus="clearErrorField('date_sortie')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_sortie')">
                                        {{ getErrorsField('date_sortie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="histoire-group"
                                        :label="$t('message.clinicalHistory')"
                                        label-for="histoire"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="histoire"
                                            v-model="$v.form.histoire_clinique.$model"
                                            :state="$v.form.histoire_clinique.$dirty ? !(errorshasField('histoire_clinique') || $v.form.histoire_clinique.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('histoire_clinique')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="!$v.form.histoire_clinique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <span v-if="histoireClinque" class="obligatoire2">
                                        {{ $t('message.requiredField') }}
                                    </span>

                                    <b-form-invalid-feedback v-if="errorshasField('histoire_clinique')">
                                        {{ getErrorsField('histoire_clinique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="lifestyle-group"
                                        :label="$t('message.lifestyle')"
                                        label-for="lifestyle"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="lifestyle"
                                            v-model="$v.form.mode_de_vie.$model"
                                            :state="$v.form.mode_de_vie.$dirty ? !(errorshasField('mode_de_vie') || $v.form.mode_de_vie.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('mode_de_vie')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('mode_de_vie')">
                                        {{ getErrorsField('mode_de_vie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="clinique-group"
                                        :label="$tc('message.physicalExams', 2)"
                                        label-for="clinique"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="clinique"
                                            v-model="$v.form.examen_clinique.$model"
                                            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_clinique')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_clinique')">
                                        {{ getErrorsField('examen_clinique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="complementaire-group"
                                        :label="$tc('message.complementaryExams', 2)"
                                        label-for="complementaire"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="complementaire"
                                            v-model="$v.form.examen_complementaire.$model"
                                            :state="$v.form.examen_complementaire.$dirty ? !(errorshasField('examen_complementaire') || $v.form.examen_complementaire.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_complementaire')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_complementaire')">
                                        {{ getErrorsField('examen_complementaire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="conclusion-group"
                                        :label="$t('message.conclusion')"
                                        label-for="conclusion">
                                    <editor
                                            :api-key="tinyKey"
                                            id="conclusion"
                                            v-model="$v.form.conclusion.$model"
                                            :state="$v.form.conclusion.$dirty ? !(errorshasField('conclusion') || $v.form.conclusion.$error) : null"
                                            placeholder=""
                                            rows="5"
                                            @focus="clearErrorField('conclusion')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('conclusion')">
                                        {{ getErrorsField('conclusion') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                          <b-col sm="12">
                            <b-form-group
                                id="evolution-group"
                                :label="$t('message.evolution')"
                                label-for="evolution">
                              <editor
                                  :api-key="tinyKey"
                                  id="evolution"
                                  v-model="$v.form.evolution.$model"
                                  :state="$v.form.evolution.$dirty ? !(errorshasField('evolution') || $v.form.evolution.$error) : null"
                                  placeholder=""
                                  @focus="clearErrorField('evolution')"
                                  :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                              >
                              </editor>

                              <b-form-invalid-feedback v-if="errorshasField('evolution')">
                                {{ getErrorsField('evolution') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="avis-group"
                                        :label="$t('message.avis')"
                                        label-for="avis"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="avis"
                                            v-model="$v.form.avis.$model"
                                            :state="$v.form.avis.$dirty ? !(errorshasField('avis') || $v.form.avis.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('avis')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('avis')">
                                        {{ getErrorsField('avis') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="traitement-group"
                                        :label="$t('message.exitTreatment')"
                                        label-for="traitement"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="traitement"
                                            v-model="$v.form.traitement_sortie.$model"
                                            :state="$v.form.traitement_sortie.$dirty ? !(errorshasField('traitement_sortie') || $v.form.traitement_sortie.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('traitement_sortie')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('traitement_sortie')">
                                        {{ getErrorsField('traitement_sortie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="rendez-group"
                                        :label="$t('message.appointmentDate')"
                                        label-for="consultation"
                                        description="">
                                    <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.rendez_vous.$model"></vue-ctk-date-time-picker>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="traitement-appointmentReason-group"
                                        :label="$t('message.appointmentReason')"
                                        label-for="appointmentReason"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="appointmentReason"
                                            v-model="$v.form.motifRdv.$model"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-container>
                        <b-row class="justify-content-center">
                            <b-button @click="onSubmit" variant="primary" v-if="can">
                                {{ $t('message.save') }}
                            </b-button>

                            <!--                            <b-button type="reset" variant="danger" v-if="can">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import moment from "moment";
    import axios from 'axios';
    import Multiselect from 'vue-multiselect'
    import SlimSelect from "slim-select";
    import Editor from "@tinymce/tinymce-vue";
    import AppConfig from "../../constants/AppConfig";
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'

    export default {
        name: "AddHospitalisation",
        components: {
            editor: Editor,
            Multiselect,
            Autocomplete
        },
        computed: {
            ...mapGetters(["errors",
                "file",
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                "userInstitutions",
                "reasons",
                'hasPraticienRole','Timelines']),

            mInstitutions: function() {
                let iArray = [];

                _.forEach(_.orderBy(this.userInstitutions,['created_at'],['desc']), function(institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                    i.date = moment(institution.created_at).format('DD-MM-YYYY');
                    i.id = institution.id;
                    i.slug = institution.slug;

                    iArray.push(i);
                });

                return iArray;
            },

            mReasons:function(){
                let rArray = [];

                if (!_.isUndefined(this.reasons)){
                    _.forEach(this.reasons ,function (reason) {
                        rArray.push({text:reason.description, value : reason.id})
                    })
                    return rArray;
                }
                return  rArray;
            },
            
            mFiles: function() {

                let value = this.file;
                if (typeof value.patient == "object"){
                    let user = value.patient.user;
                    let prenom = (user.prenom != null ? user.prenom : '');
                    prenom =  prenom.toLowerCase();
                    let fullName =  ( user.nom ).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    let info = fullName + " ( "+ value.numero_dossier + " ) " ;
                   return info;
                }

                return "";
            },

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return  this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
                }
            },
            lignetempsRows: function () {
            let self = this;
            let mArray = [];
            _.forEach(_.orderBy(self.Timelines, ['created_at'], ['desc']), function (timelines) {
                let motifs = "";
                let ids = "";

                if (timelines.hasOwnProperty('motif')) {

                    motifs = timelines.motif.description;
                    // ligne_de_temps_id = timelines.id;
                    // console.log('dossier_medical_id', dossier);
                    console.log('ligne_de_temps_id', timelines);
                    // console.log('ligne_de_temps_id', motifs);

                    if (motifs.length > 105) {
                        motifs = timelines.motif.description.substring(0, 105) + " ...";
                    }
                }
                mArray.push({
                    id: timelines.id,
                    date: timelines.date_consultation,
                    motif: motifs,
                    etat: timelines.etat == null ? true : false,
                });
            });
            let sArray = mArray;
            mArray = self.filterResult(sArray, mArray);
            return mArray;
            },
        },

        data() {
            return {
                missions: [],
                tinyKey:AppConfig.tinyMceKey,
                plugins : [
                    'advlist autolink lists  image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table'
                ],
                toolbar : 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
                file_id: this.$route.params.file,
                form: {
                    motifs:[],
                    activity_id: '',
                    ligne_de_temps_id: [],
                    institution:null,
                    date_entree: null,
                    date_sortie: null,
                    histoire_clinique: '',
                    mode_de_vie: '',
                    evolution: '',
                    examen_clinique: '',
                    examen_complementaire: '',
                    conclusion: '',
                    avis: '',
                    traitement_sortie: '',
                    etablissement_id:null,
                    rendez_vous: null,
                    motifRdv:null
                },
                show: true,
                histoireClinque : false,
            }
        },

        methods: {
            
            getEtablisssements(input){
                return new Promise(resolve => {
                    if (input.length < 2) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.etablissements)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueEtablissement(result) {
                return result.name
            },
            chooseEtablissement(result) {
                this.form.etablissement_id = result.id;
            },
            getGroupeActivites: function () {
                axios
                    .get(AppConfig.apiUrl + "/mission/list")
                    .then((res) => {this.missions = res.data.activites.map((x )=> ({
                        id: x.id,
                        description_fr: x.description_fr
                    }))})
                    .catch((error) => {window.console.log(error)});
            },
            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },
            filterResult(sArray, mArray) {
                if (this.filteredValue == 1) {
                    mArray = sArray;
                } else if (this.filteredValue == 2) {
                    //Non archivés
                    mArray = _.filter(mArray, function (medecine) {
                        return _.isNull(medecine.archievedAt);
                    })
                } else if (this.filteredValue == 3) {
                    //Non transmis
                    mArray = _.filter(mArray, function (medecine) {
                        return _.isNull(medecine.passedAt);
                    })
                } else if (this.filteredValue == 4) {
                    //Archivés
                    mArray = _.filter(mArray, function (medecine) {
                        return !_.isNull(medecine.archievedAt);
                    })
                } else if (this.filteredValue == 5) {
                    //Transmis
                    mArray = _.filter(mArray, function (medecine) {
                        return !_.isNull(medecine.passedAt);
                    })
                }
                return mArray;
            },

            getReasons() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getReasons', { args : args });
            },
            
            getMedicalFile() {
                let args = {
                    file: this.file_id
                };

                this.$store.dispatch("getMedicalFile", { args });
            },
            getTimelines() {
                let args = {
                    file: this.file_id,
                };
                
                this.$store.dispatch("getTimelines", {
                    args
                });
            },

            onSubmit: function(evt) {
                evt.preventDefault();
                if ((this.$v.form.histoire_clinique.$model).length == 0){
                    this.histoireClinque = true;
                }else{
                    this.histoireClinque = false;
                }
                this.$v.$touch();

                if(!this.$v.$invalid) {
                    if (!_.isNull(this.form.dateRdv)){
                        this.form.rendez_vous = moment(this.form.rendez_vous).format('YYYY-MM-DD HH:mm');
                    }
                    let args = {
                        dossier_medical_id: this.file.id,
                        ligne_de_temps_id:this.form.ligne_de_temps_id,
                        activity_id:this.form.activity_id,
                        date_entree: this.form.date_entree,
                        date_sortie: this.form.date_sortie,
                        histoire_clinique: this.form.histoire_clinique,
                        mode_de_vie: this.form.mode_de_vie,
                        evolution: this.form.evolution,
                        examen_clinique: this.form.examen_clinique,
                        examen_complementaire: this.form.examen_complementaire,
                        conclusion: this.form.conclusion,
                        avis: this.form.avis,
                        traitement_sortie: this.form.traitement_sortie,
                        rendez_vous: this.form.rendez_vous,
                        etablissement_id:this.form.institution,
                        motifs:this.form.motifs,
                        motifRdv:this.form.motifRdv,
                    };

                    let successMessage = this.$i18n.t('message.hospitalisationCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createHospitalisation', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.date_entree = '';
                this.form.date_sortie = '';
                this.form.histoire_clinique = '';
                this.form.mode_de_vie = '';
                this.form.evolution = '';
                this.form.examen_clinique = '';
                this.form.examen_complementaire = '';
                this.form.conclusion = '';
                this.form.avis = '';
                this.form.traitement_sortie = '';
                this.form.rendez_vous = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                etablissement_id:{required},
                activity_id:{
                    required
                },
                date_entree: {
                    required
                },
                motifs:{
                    required
                },
                ligne_de_temps_id: {
                    required
                },
                institution: {
                    required
                },
                date_sortie: {
                    //
                },
                histoire_clinique: {
                    required
                },
                mode_de_vie: {
                    //
                },
                evolution: {
                    //
                },
                conclusion: {
                    //
                },
                avis: {
                    //
                },
                traitement_sortie: {
                    //
                },
                rendez_vous: {
                    //
                },
                examen_clinique: {
                    //
                },
                examen_complementaire: {
                    //
                },
                motifRdv:{}
            }
        },

        mounted() {
            this.getGroupeActivites();
            // Retrieve list of medical files
            this.getMedicalFile();

            this.getTimelines();

            // Fetch user institution list
            this.getUserInstitutions();

            // Fetch reason list
            this.getReasons();

            var  singleMotif  =  new SlimSelect({
                select: '#singleMotif',
                placeholder: 'Select or add reason',
                addable: function (value) {
                    if (singleMotif.selected().length == 5){
                        return false;
                    }
                    else{

                        // Return the value string
                        return value // Optional - value alteration // ex: value.toLowerCase()

                    }
                },
                limit:5

            });
            new SlimSelect({
              select: '#timeLine',
              placeholder: 'Select or add timeLine',
              limit: 5

            });

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
                limit:1
            });
        }
    }
</script>

<style scoped>

</style>